// relative
import { subscriptionManagerApiSlice } from '../apiSlice';

export const stateCodeApiSlice = subscriptionManagerApiSlice.injectEndpoints({
  tagTypes: ['Subscription', 'Building'],
  endpoints: (builder) => ({
    putPauseStateCode: builder.mutation({
      query: ({ id }) => ({
        url: `/pause/${id}`,
        method: 'PUT',
      }),
      invalidatesTags: ['Subscription', 'Building'],
      transformResponse: (response, meta) => {
        // Access the Location header
        const locationHeader = meta?.response?.headers.get('Location');
        // Return the original response and the extracted ID
        return { data: response, location: locationHeader };
      },
    }),

    putResumeStateCode: builder.mutation({
      query: ({ id }) => ({
        url: `/resume/${id}`,
        method: 'PUT',
      }),
      invalidatesTags: ['Subscription', 'Building'],
      transformResponse: (response, meta) => {
        // Access the Location header
        const locationHeader = meta?.response?.headers.get('Location');
        // Return the original response and the extracted ID
        return { data: response, location: locationHeader };
      },
    }),

    putActivateStateCode: builder.mutation({
      query: ({ id }) => ({
        url: `/activate/${id}`,
        method: 'PUT',
      }),
      invalidatesTags: ['Subscription', 'Building'],
      transformResponse: (response, meta) => {
        // Access the Location header
        const locationHeader = meta?.response?.headers.get('Location');
        // Return the original response and the extracted ID
        return { data: response, location: locationHeader };
      },
    }),

    putResetInitializationStateCode: builder.mutation({
      query: ({ id }) => ({
        url: `/reset_initialization/${id}`,
        method: 'PUT',
      }),
      invalidatesTags: ['Subscription', 'Building'],
      transformResponse: (response, meta) => {
        // Access the Location header
        const locationHeader = meta?.response?.headers.get('Location');
        // Return the original response and the extracted ID
        return { data: response, location: locationHeader };
      },
    }),
  }),
});

export const {
  usePutPauseStateCodeMutation,
  usePutResumeStateCodeMutation,
  usePutActivateStateCodeMutation,
  usePutResetInitializationStateCodeMutation,
} = stateCodeApiSlice;
